<template>
  <div class="examdetail">
    <v-head :bg="'#272727'"></v-head>
    <div
      class="container"
      style="margin-top:60px;min-width:1200px;flex: 1;display: flex;flex-direction: column;"
    >
      <!-- logo-details -->
      <div class="examdetail-logohead">
        <div class="logohead-bread">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/exam' }">问卷</el-breadcrumb-item>
            <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
      <!-- main -->
      <!-- 校园精准服务系统问卷调查 -->
      <div class="examdetail-main" v-if="id === 0">
        <div class="examdetail-det">
          <div class="examdetail-title">校园精准服务系统问卷调查</div>
          <div class="examdetail-intro">您好！感谢您一如既往的对校园精准服务系统的支持。为不断完善我们的服务水平，我们诚挚的邀请您激进型满意度评价与问题反馈。</div>
        </div>
        <div class="examdetail-checkbox">
          <!-- 1 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">1、您的性别？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox.gender" label="1">A、男</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.gender" label="2">B、女</el-radio>
              </div>
            </div>
          </div>
          <!-- 2 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">2、您的年龄段？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox.age" label="1">A、18岁以下</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.age" label="2">B、18岁 - 20岁</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.age" label="3">C、21岁 - 25岁</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.age" label="4">D、26岁 - 30岁</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.age" label="5">E、30岁以上</el-radio>
              </div>
            </div>
          </div>
          <!-- 3 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">3、您的职业是？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox.career" label="1">A、学生党</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.career" label="2">B、上班族</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.career" label="3">C、白领</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.career" label="4">D、宝妈</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.career" label="5">E、工人</el-radio>
              </div>
            </div>
          </div>
          <!-- 4 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">4、您的月收入是多少？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox.income" label="1">A、1000以下</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.income" label="2">B、1000 - 2000</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.income" label="3">C、2000 - 4000</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.income" label="4">D、4000 - 6000</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.income" label="5">E、6000以上</el-radio>
              </div>
            </div>
          </div>
          <!-- 5 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">5、您的月支出（生活费）是多少？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox.outlay" label="1">A、1000以下</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.outlay" label="2">B、1000 - 2000</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.outlay" label="3">C、2000 - 4000</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.outlay" label="4">D、4000 - 6000</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.outlay" label="5">E、6000以上</el-radio>
              </div>
            </div>
          </div>
          <!-- 6 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">6、您是否使用过到梦空间？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox.use" label="1">A、使用过</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox.use" label="2">B、没使用过</el-radio>
              </div>
            </div>
          </div>
          <!-- 7 -->
          <div class="examdetail-checkbox-item" v-if="radiobox.use === '2'">
            <div class="examdetail-item-title">7、您是否使用过到梦空间？</div>
            <div class="examdetail-item-textarea">
              <el-input
                type="textarea"
                class="textarea"
                :autosize="{ minRows: 3, maxRows: 8}"
                placeholder="请输入内容"
                v-model="radiobox.reason"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <!-- 关于抖音的品牌知名度的调查问卷 -->
      <div class="examdetail-main" v-if="id === 1">
        <div class="examdetail-det">
          <div class="examdetail-title">关于抖音的品牌知名度的调查问卷</div>
          <div class="examdetail-intro">您好！感谢您一如既往的对校园精准服务系统的支持。为不断完善我们的服务水平，我们诚挚的邀请您激进型满意度评价与问题反馈。</div>
        </div>
        <div class="examdetail-checkbox">
          <!-- 1 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">1、您的性别？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.gender" label="1">A、男</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.gender" label="2">B、女</el-radio>
              </div>
            </div>
          </div>
          <!-- 2 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">2、您处在哪一个年龄层次？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.age" label="1">A、18岁以下</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.age" label="2">B、18岁 - 25岁</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.age" label="3">C、26岁 - 30岁</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.age" label="4">D、30岁以上</el-radio>
              </div>
            </div>
          </div>
          <!-- 3 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">3、你目前的职业是？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.career" label="1">A、学生</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.career" label="2">B、企业或公司职员</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.career" label="3">C、个体/自由工作者</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.career" label="4">D、离退休人员/下岗/失业</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.career" label="5">E、其他</el-radio>
              </div>
            </div>
          </div>
          <!-- 4 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">4、您听说过抖音吗？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.income" label="1">A、听说过</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.income" label="2">B、没听说过</el-radio>
              </div>
            </div>
          </div>
          <!-- 5 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">5、请你写出您在听到（看到）下列词语最先联想的词语：抖音_______</div>
            <div class="examdetail-item-textarea">
              <el-input
                type="text"
                class="textarea"
                size="small"
                placeholder="请填写您最先联想的词语"
                v-model="radiobox_1.dy_word"
              ></el-input>
            </div>
          </div>
          <!-- 6 -->
          <div class="examdetail-checkbox-item">
            <div
              class="examdetail-item-title"
            >6、就观看视频的app来说，您还知道哪些？还有呢？还有呢？（追问至无结果为止） 第一联想（1） 其他联想（2） （3） （4）</div>
            <div class="examdetail-item-textarea">
              <el-input
                type="textarea"
                class="textarea"
                :autosize="{ minRows: 3, maxRows: 8}"
                placeholder="请输入内容"
                v-model="radiobox_1.dy_videoWord"
              ></el-input>
            </div>
          </div>
          <!-- 7 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">7、您是通过什么渠道知道抖音的？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.channel" label="1">A、应用商城</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.channel" label="2">B、朋友推荐</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.channel" label="3">C、社交应用（微博，微信QQ等）</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.channel" label="4">D、广告宣传</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.channel" label="5">E、其他</el-radio>
              </div>
            </div>
          </div>
          <!-- 8 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">8、您使用过抖音吗？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.user" label="1">A、使用过</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.user" label="2">B、没使用过</el-radio>
              </div>
            </div>
          </div>
          <!-- 9 -->
          <div class="examdetail-checkbox-item" v-if="radiobox_1.user === '2'">
            <div class="examdetail-item-title">9、您听过但没有使用过抖音的原因？</div>
            <div class="examdetail-item-textarea">
              <el-input
                type="text"
                class="textarea"
                size="small"
                placeholder="请填写原因"
                v-model="radiobox_1.noUserReason"
              ></el-input>
            </div>
          </div>
          <!-- 10 -->
          <div class="examdetail-checkbox-item" v-if="radiobox_1.user === '1'">
            <div class="examdetail-item-title">10、您使用抖音多久了？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.useDate" label="1">A、少于一个月</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.useDate" label="2">B、1~6个月</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.useDate" label="3">C、7~12个月</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.useDate" label="4">D、12个月及以上</el-radio>
              </div>
            </div>
          </div>
          <!-- 11 -->
          <div class="examdetail-checkbox-item" v-if="radiobox_1.user === '1'">
            <div class="examdetail-item-title">11、您使用抖音的频率是？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.frequency" label="1">A、每天一次</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.frequency" label="2">B、每天两次及以上</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.frequency" label="3">C、两三天一次</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.frequency" label="4">D、每周一次</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.frequency" label="5">D、基本不用</el-radio>
              </div>
            </div>
          </div>
          <!-- 12 -->
          <div class="examdetail-checkbox-item" v-if="radiobox_1.frequency === '5'">
            <div class="examdetail-item-title">12、您基本不用（卸载）抖音的原因是什么？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_1.deleteReason">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、基本不用视频方面的软件</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、用过但感觉操作上不好用</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、视频内容不吸引人</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、功能太少无法满足需求</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="5">E、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <!-- 13 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">13、您每次使用抖音的时长？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.useTime" label="1">A、5分钟以下</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.useTime" label="2">B、5~30分钟</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.useTime" label="3">C、30~60分钟</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.useTime" label="4">D、一小时以上</el-radio>
              </div>
            </div>
          </div>
          <!-- 14 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">14、您使用抖音的目的是？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_1.purpose">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、展现自我</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、记录生活</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、消遣娱乐</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、技能学习</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="5">E、追星</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="6">F、关注社会热点</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="7">G、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <!-- 15 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">15、您观看抖音视频时</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.looking" label="1">A、更倾向于观看关注的人的视频</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.looking" label="2">B、更倾向于看附近的视频</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.looking" label="3">C、没有特定的观看对象</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.looking" label="4">D、其他</el-radio>
              </div>
            </div>
          </div>
          <!-- 16 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">16、您认为抖音吸引你的视频内容为？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_1.dy_likeContent">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、话题挑战类</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、生活技能类</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、风景旅游类</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、高颜值“小哥哥”，“小姐姐”</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="5">E、萌娃萌宠类</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="6">F、美食类</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="7">G、美妆时尚类</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="8">H、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <!-- 17 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">17、你会向朋友推荐抖音APP吗？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.recommend" label="1">A、会</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.recommend" label="2">B、不会</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_1.recommend" label="3">C、不好说</el-radio>
              </div>
            </div>
          </div>
          <!-- 18 -->
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">18、您最希望抖音改进或增加的功能是：</div>
            <div class="examdetail-item-textarea">
              <el-input
                type="textarea"
                class="textarea"
                :autosize="{ minRows: 3, maxRows: 8}"
                placeholder="请输入内容"
                v-model="radiobox_1.perfect"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
      <!-- 奶茶市场需求问卷调查 -->
      <div class="examdetail-main" v-if="id === 2">
        <div class="examdetail-det">
          <div class="examdetail-title">奶茶市场需求问卷调查</div>
          <div
            class="examdetail-intro"
          >你好，为了完成暑期开展社会调研报告，我正在进行一项关于奶茶市场需求调查，想邀请您用几分钟时间帮忙填答这份问卷。本问卷实行匿名制，所有数据只用于统计分析， 请您放心填写。题目选项无对错之分，请您按自己的实际情况填写。谢谢您的帮助。</div>
        </div>
        <div class="examdetail-checkbox">
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">1、您的性别？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.gender" label="1">A、男</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.gender" label="2">B、女</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">2、你平时喜欢喝哪一种饮料？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_2.drink">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、碳酸饮料</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、果汁类</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、奶茶类</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">3、请问你喝奶茶吗？频率是多久一次？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.drinkTime" label="1">A、总是，几乎每天</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.drinkTime" label="2">B、经常，一周几次</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.drinkTime" label="3">C、偶尔，一个月几次</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.drinkTime" label="4">D、几乎不喝</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">4、你选择奶茶主要考虑的是？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_2.searchReason">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、口味</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、价格</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、包装</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">5、您的年龄段？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.age" label="1">A、16岁以下</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.age" label="2">B、16-25岁</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.age" label="3">C、25-30岁</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.age" label="4">D、30岁以上</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">6、你通常在什么情况下喝奶茶？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_2.happening">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、口渴时</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、运动后</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、逛街时</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、聚会时</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="5">E、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">7、您认为健康喝奶茶的次数是？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.drinkFrequency" label="1">A、不喝</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.drinkFrequency" label="2">B、尽量少喝</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.drinkFrequency" label="3">C、一周两次</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.drinkFrequency" label="4">D、每周三次以上</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">8、你认为喝奶茶时的气氛？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_2.atmosphere">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、安静</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、热闹</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、舒适</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、休闲娱乐</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="5">E、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">9、你喜欢的奶茶优惠方式？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_2.offer">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、买一送一</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、优惠卷</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、会员积分</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、外卖服务</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="5">E、赠送礼品</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="6">F、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">10、如果奶茶的口感好价格贵一点你接受吗？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.priceUp" label="1">A、接受</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.priceUp" label="2">B、不接受</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">11、您喜欢喝奶茶时提供的哪些服务？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_2.service">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、杂志、书籍</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、音乐</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、棋牌</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、充电服务</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="5">E、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">12、奶茶你喜欢搭配什么？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_2.match">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、雪糕</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、蛋糕</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、小吃</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、水果</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="5">E、面食类</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="6">F、爆米花</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="7">G、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">13、促销活动会影响你对奶茶店的信任吗？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.trust" label="1">A、会</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.trust" label="2">B、不会</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">14、选择在店面喝奶茶时你会考虑店面的？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_2.surroundings">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、空间</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、环境</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、地段</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、热闹</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="5">E、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">15、你的职业是？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.career" label="1">A、学生党</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.career" label="2">B、上班族</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.career" label="3">C、白领</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.career" label="4">D、宝妈</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.career" label="5">E、工人</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.career" label="6">F、其他</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">16、你喜欢喝奶茶的原因？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_2.drinkReason">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、喜欢代言人</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、味道独特</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、生活习惯</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、品牌影响</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="5">E、休闲娱乐</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="6">E、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">17、您选择奶茶的杯型？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.cupSex" label="1">A、大杯</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.cupSex" label="2">B、中杯</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_2.cupSex" label="3">C、小杯</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">18、您喜欢奶茶怎样的包装？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_2.package">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、简约清新</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、图案丰富</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、紧跟潮流</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">19、您一般喝的奶茶的价格？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_2.price">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、5元以下</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、5-10元</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、10元-15元</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、15元-20元</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="5">E、20元-25元</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="6">F、25元-30元</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="7">G、30元以上</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">20、您认为其他饮品相对于奶茶的优点是？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_2.advantage">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、价格优惠</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、选择种类多</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、味道口感好</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
      <!-- 麻辣烫市场需求问卷调查 -->
      <div class="examdetail-main" v-if="id === 3">
        <div class="examdetail-det">
          <div class="examdetail-title">麻辣烫市场需求问卷调查</div>
        </div>
        <div class="examdetail-checkbox">
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">1、您的性别？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.gender" label="1">A、男</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.gender" label="2">B、女</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">2、您的年龄段？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.age" label="1">A、18岁以下</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.age" label="2">B、18岁-20岁</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.age" label="3">C、21岁-25岁</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.age" label="4">D、26岁-30岁</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.age" label="5">E、30岁以上</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">3、您的职业是？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.career" label="1">A、学生党</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.career" label="2">B、上班族</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.career" label="3">C、白领</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.career" label="4">D、宝妈</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.career" label="5">E、工人</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">4、您一般是在什么地方吃麻辣烫？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.eatArea" label="1">A、学校</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.eatArea" label="2">B、小区门口</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.eatArea" label="3">C、商场周边</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">5、请问您吃麻辣烫的频率是多少？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.frequency" label="1">A、总是，几乎每天</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.frequency" label="2">B、经常，一周几次</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.frequency" label="3">C、偶尔，一个月几次</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.frequency" label="4">D、几乎不吃</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">6、您吃麻辣烫的口味是什么？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.taste" label="1">A、偏辣</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.taste" label="2">B、偏甜</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.taste" label="3">C、清汤</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">7、您喜欢什么优惠活动？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_3.offer">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、代金卷</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、集赞送饮料</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、打折</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、买一送一</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">8、您会考虑在什么店面环境吃麻辣烫？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_3.surroundings">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、空间</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、卫生</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、安静</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、热闹</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">9、您一般吃麻辣烫的价格？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_3.price">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、10元以下</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、10元-15元</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、16元-20元</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、20元—25元</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="5">E、25元以上</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">10、您喜欢吃麻辣烫的原因是什么？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_3.reason">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、价格优惠</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、选择种类多</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、味道口感好</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">11、您吃麻辣烫会选择？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_3.eatSearch">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、价格便宜</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、量多</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、味道好</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、环境好</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">12、以下哪家麻辣烫店您最常光顾呢？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.careArea" label="1">A、刁四麻辣烫</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.careArea" label="2">B、杨国福麻辣烫</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.careArea" label="3">C、吉阿婆麻辣烫</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.careArea" label="4">D、一杆秤麻辣烫</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.careArea" label="5">E、阿上阿上麻辣烫</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">13、您偏爱这家麻辣烫的原因是？</div>
            <div class="examdetail-item-radio">
              <el-checkbox-group v-model="radiobox_3.likeReason">
                <div class="item-radio-line">
                  <el-checkbox label="1">A、菜品种类丰富</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="2">B、菜品新鲜干净</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="3">C、价格实惠</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">D、快捷方便</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">E、口味独特</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">F、分店较多</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">G、环境整洁</el-checkbox>
                </div>
                <div class="item-radio-line">
                  <el-checkbox label="4">H、其他</el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">14、逛街的时候你会去吃麻辣烫吗？</div>
            <div class="examdetail-item-radio">
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.shoppingTo" label="1">A、会</el-radio>
              </div>
              <div class="item-radio-line">
                <el-radio v-model="radiobox_3.shoppingTo" label="2">B、不会</el-radio>
              </div>
            </div>
          </div>
          <div class="examdetail-checkbox-item">
            <div class="examdetail-item-title">15、大家对麻辣烫店有什么建议</div>
            <div class="examdetail-item-textarea">
              <el-input
                type="textarea"
                class="textarea"
                :autosize="{ minRows: 3, maxRows: 8}"
                placeholder="请输入内容"
                v-model="radiobox_3.opinion"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>
<script>
import vHead from '@/components/header/header.vue'
import vFooter from '@/components/footer/footer.vue'
import {
  Breadcrumb,
  BreadcrumbItem,
  Radio,
  Input,
  Button,
  Checkbox,
  CheckboxGroup
} from 'element-ui'
export default {
  data () {
    return {
      id: this.$route.query.id,
      title: this.$route.query.title,
      // 校园精准服务问卷调查参数
      radiobox: {
        gender: '', // 您的性别
        age: '', // 年龄
        career: '', // 职业
        income: '', // 月收入
        outlay: '', // 月支出
        use: '', // 是否使用过到梦空间
        reason: '' // 没有使用到梦空间的原因
      },
      // 关于抖音的品牌知名度的调查问卷
      radiobox_1: {
        gender: '',
        age: '',
        career: '',
        income: '',
        deleteReason: [],
        purpose: [],
        dy_likeContent: [],
        dy_word: '',
        dy_videoWord: '',
        channel: '',
        user: '',
        noUserReason: '',
        useDate: '',
        frequency: '',
        useTime: '',
        looking: '',
        recommend: '',
        perfect: ''
      },
      // 奶茶市场需求问卷调查
      radiobox_2: {
        gender: '',
        drink: [],
        drinkTime: '',
        searchReason: [],
        age: '',
        happening: [],
        drinkFrequency: '',
        atmosphere: [],
        offer: [],
        priceUp: '',
        service: [],
        match: [],
        trust: '',
        surroundings: [],
        career: '',
        drinkReason: [],
        cupSex: '',
        package: [],
        price: [],
        advantage: []
      },
      // 麻辣烫市场需求问卷调查
      radiobox_3: {
        gender: '',
        age: '',
        career: '',
        eatArea: '',
        frequency: '',
        taste: '',
        offer: [],
        surroundings: [],
        price: [],
        reason: [],
        eatSearch: [],
        careArea: '',
        likeReason: [],
        shoppingTo: '',
        opinion: ''
      }
    }
  },
  components: {
    'v-head': vHead,
    'v-footer': vFooter,
    'el-breadcrumb': Breadcrumb,
    'el-breadcrumb-item': BreadcrumbItem,
    'el-radio': Radio,
    'el-input': Input,
    'el-button': Button,
    'el-checkbox': Checkbox,
    'el-checkbox-group': CheckboxGroup
  },
  created () {
    // 移动端适配最小高度为浏览器高度
    this.$nextTick(() => {
      let containerDom = document.getElementsByClassName('container')[0]
      if (containerDom) {
        containerDom.style.minHeight = (document.documentElement.clientHeight - 100) + 'px'
      }
    })
  },
  methods: {
  }
}
</script>
<style lang="scss" src="./examdetail_active.scss"></style>
<style lang="scss" scoped>
.examdetail {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;
  // logo-details
  .examdetail-logohead {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    margin-bottom: 15px;
    .logohead-bread {
      padding: 20px 0;
      border-bottom: 1px solid #eeeeee;
    }
  }
  .examdetail-main {
    width: 1200px;
    margin: 0 auto;
    padding: 30px 35px;
    background-color: #ffffff;
    box-sizing: border-box;
    margin-bottom: 45px;
    .examdetail-det {
      padding-bottom: 45px;
      border-bottom: 4px solid #2178ec;
      margin-bottom: 25px;
      .examdetail-title {
        font-size: 14px;
        font-weight: 700;
        padding: 15px 0 25px 0;
      }
      .examdetail-intro {
        font-size: 12px;
        line-height: 20px;
        color: #999999;
      }
    }
    .examdetail-checkbox {
      .examdetail-checkbox-item {
        padding-bottom: 15px;
        .examdetail-item-title {
          font-size: 14px;
          color: #333333;
          line-height: 32px;
        }
        .examdetail-item-radio {
          .item-radio-line {
            line-height: 32px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" >
.examdetail {
  .textarea textarea,
  .textarea input {
    font-size: 14px;
    color: #333333;
  }

  .el-checkbox__label {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/exam/examdetail.vue